import React from "react"; 

import { Row, Col, Container } from 'reactstrap'; 
 
import CardSelect from 'components/Landpage/Card/Select'

import { 
    BannerImage,
    BannerOut,
    BannerContent
} from "./styled"; 


import { ButtonContent, ContentCenter, Subtitle, Title } from "ui/styled";
import Button from "components/Form/Button";
import { goContact } from "utils";


export default function BannerMiddle(){

    return ( 
        <> 
            <BannerImage>
                <BannerOut />
                <BannerContent>
                    <Container>
                        <Row>
                            <Col md={{ size: 8 }}> 
                                <ContentCenter>
                                    <Subtitle>Projetos personalizados</Subtitle>
                                    <Title>Cada cliente é único e que cada projeto tem suas particularidades e necessidades específicas.</Title>

                                    <ButtonContent>
                                        <Button outline onClick={goContact}>Entrar em contato</Button>
                                    </ButtonContent>

                                </ContentCenter>
                            </Col>
                        </Row>
                    </Container>
                </BannerContent>
            </BannerImage>
        </>
    );
}